/* Progressive enhancement: native content and links work before this script. */
(() => {
  if (window.rsFineMotionReady) return;
  window.rsFineMotionReady = true;
  const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
  const observed = new WeakSet();
  const active = new Set();
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      if (preference.matches || window.Shopify?.designMode || !entry.target.animate) return;
      if (entry.target.hasAttribute('data-rs-fine-scene')) entry.target.classList.add('rs-fine-in-view');
      const animation = entry.target.animate([
        {opacity:0.45, transform:'translateY(12px)'},
        {opacity:1, transform:'translateY(0)'}
      ], {duration:560, easing:'cubic-bezier(.2,.65,.25,1)', iterations:1});
      active.add(animation);
      animation.finished.catch(() => {}).finally(() => active.delete(animation));
    });
  }, {threshold:0.08}) : null;
  const init = root => {
    if (!observer || preference.matches || window.Shopify?.designMode) return;
    root.querySelectorAll('[data-rs-fine-reveal]').forEach(el => {
      if (observed.has(el)) return;
      observed.add(el);
      // Above-the-fold content never waits for a reveal.
      if (el.getBoundingClientRect().top < window.innerHeight) return;
      observer.observe(el);
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-rs-fine-reveal]').forEach(el => observer?.unobserve(el));
  });
  preference.addEventListener('change', () => {
    if (preference.matches) {active.forEach(animation => animation.cancel());observer?.disconnect();}
  });
})();
